module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    class: _vm.bemFacet
  }, [_c('div', {
    staticClass: "modal--close-wrap"
  }, [_c('div', {
    staticClass: "modal--close"
  }, [_c('button', {
    staticClass: "modal--close-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeOverlay($event)
      }
    }
  }, [_c('cmp-icon', {
    attrs: {
      "symbol": "close",
      "size": "large"
    }
  })], 1)])]), _vm._v(" "), (!!_vm.$slots.header) ? _c('header', {
    staticClass: "modal--header"
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), (!!_vm.$slots.default) ? _c('main', {
    staticClass: "modal--body"
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (!!_vm.$slots.footer) ? _c('footer', {
    staticClass: "modal--footer"
  }, [_vm._t("footer")], 2) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2afa7267", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2afa7267","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/ui/modal/index.vue
// module id = 522
// module chunks = 7